import React from "react";
import { Badge } from "reactstrap";

const EmployeeStatusBadge = ({ status }) => {
  let color;
  let displayText;

  switch (status) {
    case "Paid":
      color = "success"; // Green
      displayText = "Paid";
      break;
    case "Pending":
      color = "warning"; // Yellow/Orange
      displayText = "Pending";
      break;
    case "Overdue":
      color = "danger"; // Red
      displayText = "Overdue";
      break;
    case "Completed":
      color = "info"; // Blue
      displayText = "Completed";
      break;
    default:
      color = "light"; // Light gray for unknown status
      displayText = status || "Unknown";
  }

  return (
    <Badge 
      color={color} 
      style={{ 
        padding: "6px 12px", 
        fontSize: "12px",
        fontWeight: "500",
        borderRadius: "20px"
      }}
    >
      {displayText}
    </Badge>
  );
};

export default EmployeeStatusBadge;
